<template>
  <el-collapse v-model="selectorActive" accordion>
    <el-collapse-item title="Questions" name="questions">
      <template slot="title">
        <h3>Questions</h3>
      </template>
      <question-selector :isFixed="selectorFixed" :isEditable="survey.isPreview"></question-selector>
    </el-collapse-item>

    <el-collapse-item name="templates">
      <template slot="title">
        <h3>Template for choices</h3>
      </template>
      <choice-template-selector :isFixed="selectorFixed" :isEditable="survey.isPreview"></choice-template-selector>
    </el-collapse-item>

    <el-collapse-item name="choices">
      <template slot="title">
        <h3>Choices</h3>
      </template>
      <choice-selector :isFixed="selectorFixed" :isEditable="survey.isPreview"></choice-selector>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapState } from 'vuex';

import ChoiceSelector from '../selectors/ChoiceSelector';
import QuestionSelector from '../selectors/QuestionSelector';
import ChoiceTemplateSelector from '../selectors/ChoiceTemplateSelector';

export default {
  name: 'QualitativeSelectorTab',
  components: {
    ChoiceSelector,
    ChoiceTemplateSelector,
    QuestionSelector,
  },
  props: {
    selectorFixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectorActive: 'questions',
  }),
  computed: {
    ...mapState('surveybuilder', ['survey']),
  },
};
</script>



// WEBPACK FOOTER //
// QualitativeSelectorTab.vue?2bab54f0